import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { Customerservice } from 'src/app/model/customerservice.model';
import { CustomergroupService } from 'src/app/services/customergroup.service';
import { RemoveModalCustomerserviceUserComponent } from 'src/app/modal/remove-modal-customerservice-user/remove-modal-customerservice-user.component';
import { ChangeUserGroupComponent } from 'src/app/modal/change-user-group/change-user-group.component';
import { ChangeUserGroupSingleComponent } from 'src/app//modal/change-user-group-single/change-user-group-single.component';
@Component({
  standalone: false,
  selector: 'app-list-customer-service-user',
  templateUrl: './list-customer-service-user.component.html',
  styleUrls: ['./list-customer-service-user.component.scss']
})
export class ListCustomerServiceUserComponent implements OnInit {

  public customerservice = new Customerservice();
  private subscriptions = new Subscription();

  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  mainServiceUserList = [];
  newmainServiceUserList = [];
  mainGroups = [];
  masterSelectedUsers: boolean;
  showDropdown: boolean = false;
  checkedUsersList: any;
  selectedGroupName: any;
  multiSelectGroup: any;
  usersDeepCopy: any;
  newMainUsers: any;
  totalCount;
  displayCount;
  usersTempNew: any;
  searchGroup: string = '';
  searchserviceUserList = [];
  groupId: string = null;
  fromDetailsPage: any;
  checkedOnlyUsersList: any;
  singleUserId: any;
  checkLengthOfUser: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private customergroupService: CustomergroupService,
  ) {
    localStorage.setItem('expandNavUser', 'true');

    const route = this.sideNavService.routingChunks({
      name: 'Users',
      subNav: '2',
      subNavLink: '',
      //subNavLink: '/landscaping-and-vegetation/list-of-plants-trees',
    });
    this.appStateSrv.setSideNavState(route);
  }

  ngOnInit(): void {

    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;
    this.groupId = null;
    this.fromDetailsPage = 'No';

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.getTheMainServiceGroupList();
    this.getTheMainServiceUserList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavUser');
    this.subscriptions.unsubscribe();
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    if (this.searchserviceUserList.length > 0) {
      this.newmainServiceUserList = this.searchserviceUserList.filter((item: { userNameInShort: any }) => {
        return item.userNameInShort.toLowerCase().includes(event.toLowerCase());
      });
    } else {
      this.newmainServiceUserList = this.mainServiceUserList.filter((item: { userNameInShort: any }) => {
        return item.userNameInShort.toLowerCase().includes(event.toLowerCase());
      });
    }
    this.totalRows = this.newmainServiceUserList?.length;

    if (event == '') {
      if (this.multiSelectGroup == 'All') {
        this.newmainServiceUserList = this.mainServiceUserList;
      } else {
        console.log(this.searchserviceUserList);
        if (this.searchserviceUserList.length > 0) {
          this.newmainServiceUserList = this.searchserviceUserList;
        } else {
          this.newmainServiceUserList = this.mainServiceUserList;
        }
      }
      this.totalRows = this.newmainServiceUserList?.length;
    }
  }

  handelServiceUserList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  goToServiceUserDetails(id) {
    this.router.navigate(['/view-member-details/' + id]);
  }

  getTheMainServiceUserList() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.customergroupService.getServiceUsersList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainServiceUserList = res?.list;
        this.newmainServiceUserList = res?.list;
        this.newMainUsers = res;
        this.usersDeepCopy = JSON.parse(JSON.stringify(res));
        this.usersTempNew = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.mainServiceUserList = [];
        this.newmainServiceUserList = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.mainServiceUserList?.length; i++) {
      this.mainServiceUserList[i].isSelected = false;
    }

    console.log(this.mainServiceUserList);

    this.getCheckedItemList();
  }

  getTheMainServiceGroupList() {
    this.customergroupService.getMainGroupList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainGroups = res?.list;
        const allOpt = {
          groupId: null,
          groupName: "All"
        }
        this.mainGroups.unshift(allOpt);
        this.selectedGroupName = this.mainGroups[0].groupName;
      }
    });
  }

  openModal(userName: string, userNameInShort: string, userId: string, groupId: any, fromDetailsPage: string): void {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemoveModalCustomerserviceUserComponent, modalOptions);

    modalRef.componentInstance.userName = userName;
    modalRef.componentInstance.userNameInShort = userNameInShort;
    modalRef.componentInstance.userId = userId;
    modalRef.componentInstance.groupId = groupId;
    modalRef.componentInstance.fromDetailsPage = fromDetailsPage;
  }

  openModalMoveGroup(checkedOnlyUsersList: any): void {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    if (this.checkLengthOfUser == 1) {
      const modalRef = this.modalService.open(ChangeUserGroupSingleComponent, modalOptions);
      modalRef.componentInstance.listofusers = checkedOnlyUsersList;
      modalRef.componentInstance.singleUserId = this.singleUserId;
    } else {
      const modalRef = this.modalService.open(ChangeUserGroupComponent, modalOptions);
      modalRef.componentInstance.listofusers = checkedOnlyUsersList;
    }
  }

  checkUncheckAll() {
    for (var i = 0; i < this.mainServiceUserList.length; i++) {
      this.mainServiceUserList[i].isSelected = this.masterSelectedUsers;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedUsers);
    if (this.masterSelectedUsers === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedUsers = this.mainServiceUserList.every(function (item: any) {
      return item.isSelected === true;
    });
    console.log(this.masterSelectedUsers);
    this.getCheckedItemList();
  }

  getCheckedItemList() {

    this.checkedUsersList = [];
    this.checkedOnlyUsersList = [];

    for (var i = 0; i < this.mainServiceUserList?.length; i++) {

      if (this.mainServiceUserList[i].isSelected) {

        this.checkedUsersList.push(this.mainServiceUserList[i]);
        this.checkedOnlyUsersList.push(this.mainServiceUserList[i]);

        this.showDropdown = true;
      }
    }

    this.checkLengthOfUser = this.checkedUsersList.length;
    this.checkedUsersList = JSON.stringify(this.checkedUsersList);
    this.singleUserId = this.checkedOnlyUsersList[0].userId ? this.checkedOnlyUsersList[0].userId : 0;
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  selectGroupid(item) {

    this.selectedGroupName = item.groupName;

    if (item.groupName !== null) {
      if (this.multiSelectGroup == item.groupName) {
        this.multiSelectGroup.splice(this.multiSelectGroup.indexOf(item.groupName), 1);
      } else {
        this.newMainUsers.list = this.usersDeepCopy.list;
        this.multiSelectGroup = item.groupName;
      }
    }
    else {
      this.multiSelectGroup = 'All';
    }

    if (this.multiSelectGroup != '') {
      if (this.multiSelectGroup == 'All') {
        this.newmainServiceUserList = this.usersDeepCopy.list;
      } else {
        this.newmainServiceUserList = this.mainServiceUserList.filter((item) => {
          return item.groups.includes(this.multiSelectGroup);
        });
      }
    } else {
      this.newmainServiceUserList = this.usersDeepCopy.list;
    }

    this.searchserviceUserList = this.newmainServiceUserList;

    console.log(this.newmainServiceUserList);

    this.totalRows = this.newmainServiceUserList.length;
    this.totalCount = this.newmainServiceUserList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    if (this.multiSelectGroup != '') {
      this.selectedGroupName = this.mainGroups.filter(group => group.groupName === this.multiSelectGroup)[0].groupName;
    } else {
      this.selectedGroupName = this.mainGroups[0].groupName;
    }

  }

}
